export const VerificationAgencyClientApplication = `VerificationAgencyClientApplication/`;
export const ApplicationDetails = VerificationAgencyClientApplication + `ApplicationDetails/`;
export const VAClientApplicationSearch = VerificationAgencyClientApplication + `Search`;
export const VerificationAgency = 'VerificationAgency/'; //Controller on old project

export const VerificationAgencyClient = `VerificationAgencyClient/`;
export const CreateBeeCommisioner = VerificationAgencyClient + 'CreateBeeCommisioner';
export const GetBeeCommisionerByApplicationId = VerificationAgencyClient + 'BEECommisioner/';
export const UpdateBeeCommisioner = VerificationAgencyClient + 'UpdateBeeCommisioner';
export const BeeCommisionerExternalPage = VerificationAgencyClient + 'BEECommisioner/ExternalPage/';

export const GetFinancialInformationByApplicationId = VerificationAgencyClientApplication + 'FinancialInformation/';
export const CreateFinancialInformation = VerificationAgencyClientApplication + 'CreateFinancialInformation';
export const UpdateFinancialInformation = VerificationAgencyClientApplication + 'UpdateFinancialInformation';

export const GetFinancialInformationByApplicationIdExternalPage = VerificationAgencyClientApplication + 'FinancialInformation/ExternalPage/';

export const GetServiceRequiredAndOwnershipStructureByApplicationId = VerificationAgencyClientApplication + 'ServiceRequiredAndOwnershipStructure/';
export const CreateServiceRequiredAndOwnershipStructure = VerificationAgencyClientApplication + 'CreateServiceRequiredAndOwnershipStructure';
export const UpdateServiceRequiredAndOwnershipStructure = VerificationAgencyClientApplication + 'UpdateServiceRequiredAndOwnershipStructure';
export const SendApplicationLink = VerificationAgencyClientApplication + 'SendApplicationLink/';
export const EmailApplication = VerificationAgency + 'EmailApplication/';

export const ServiceRequiredAndOwnershipStructureExternalPage = VerificationAgencyClientApplication + 'ServiceRequiredAndOwnershipStructure/ExternalPage';
export const SubmitApplication = VerificationAgencyClientApplication + 'SubmitExternalApplication/ExternalPage';
export const IsTokenActive = VerificationAgencyClientApplication + 'IsTokenActive/';

export const GetProposalByApplicationId = VerificationAgencyClientApplication + 'Proposal/';
export const CreateProposal = VerificationAgencyClientApplication + 'CreateProposal';
export const UpdateProposal = VerificationAgencyClientApplication + 'UpdateProposal';

export const RiskAssessment =  VerificationAgencyClientApplication + 'RiskAssessment';
export const RelatedParty = `${RiskAssessment}/RelatedParty`;
export const RelatedPartySearch = `${RelatedParty}/Search`;

export const GetTrackClientStatus = VerificationAgencyClientApplication + 'ClientStatus/';
export const UpdateClientStatus = VerificationAgencyClientApplication + 'ManuallyCaptureClientStatus';

export const ApplicationLinkedScorecards = VerificationAgencyClientApplication + 'SearchLinkedScorecards';
export const GetAvailableScorecardsForServiceRequired = VerificationAgencyClientApplication + 'GetAvailableScorecardsForServiceRequired';
export const GetServiceRequiredRenderedById = VerificationAgencyClientApplication + 'GetServiceRequiredRenderedById';
export const SaveServiceRequiredRendered = VerificationAgencyClientApplication + 'SaveServiceRequiredRendered';

export const GetDropdownOptions = VerificationAgencyClientApplication + 'GetDropdownOptions';
